import React from "react";

function Heading ({ text }){
return(
     <div className='flex justify-between items-center'>
<h1 className="text-2xl font-semibold mb-4 text-[var(--text-primary)]">
          {text }
        
        </h1>
        
        </div>
)
}

export default Heading;